import useSWR from "swr";
import { fetcher, FetchError } from "lib/actions/fetcher";
import { endpointsAutodeskImport } from "../actions/endpointsAutodeskImport";
import { AutodeskHubModel } from "../types/AutodeskHubModel";
import { AutodeskProjectModel } from "../types/AutodeskProjectModel";

export function useAutodeskProjects(
  connectedAccountId: number | null,
  hub: AutodeskHubModel | null,
) {
  const { data, error, isLoading, mutate } = useSWR<
    AutodeskProjectModel[],
    FetchError
  >(
    connectedAccountId !== null &&
      hub?.region &&
      endpointsAutodeskImport.projects(connectedAccountId, hub.id, hub.region),
    fetcher,
    // A background retry would swap the error panel for a spinner, dropping a
    // Reconnect that is still waiting on its popup.
    { shouldRetryOnError: false },
  );

  return { projects: data, hasError: !!error, error, isLoading, mutate };
}
